import { formatMoneyCents } from "../../../i18n/format";
import { useInterfaceLocale } from "./useInterfaceLocale";

/** USD cents in the Interface Language ("$31.91" / "31,91 $"); `approx` prefixes "≈ " for estimates. */
export function Money({
  cents,
  approx = false,
}: {
  cents: number | null | undefined;
  approx?: boolean;
}) {
  const locale = useInterfaceLocale();
  const text = formatMoneyCents(cents, locale);
  return (
    <span data-component="Money" className="tabular-nums">
      {approx && text ? "≈ " : ""}
      {text}
    </span>
  );
}
